import {
  hasEventPaymentIssue,
  hasEventLocationIssue,
  isExpiredEvent,
  allInviteesDeclined,
  eventHasInternalConflict,
  hasEventPassed,
} from 'shared/utils/get_badge_key'

export type WarningKey =
  | 'PAYMENT_ERROR'
  | 'ACTION_NEEDED'
  | 'EXPIRED'
  | 'INVITEES_DECLINED'
  | 'CONFLICT'

type CheckFn = (event: any, options: { otherEventsOnDay: any[] }, isMyCalendlyScope: boolean) => boolean

const warningChecks: Array<{ check: CheckFn; key: WarningKey }> = [
  { check: (event) => hasEventPaymentIssue(event), key: 'PAYMENT_ERROR' },
  { check: (event) => hasEventLocationIssue(event) && !hasEventPassed(event), key: 'ACTION_NEEDED' },
  { check: (event) => isExpiredEvent(event), key: 'EXPIRED' },
  { check: (event) => allInviteesDeclined(event), key: 'INVITEES_DECLINED' },
  { check: (event, options, isMyCalendlyScope) => eventHasInternalConflict(event, options, isMyCalendlyScope), key: 'CONFLICT' },
]

/**
 * Returns the highest-priority warning key for a meeting, or null if none apply.
 * Warning statuses are informational/action-required badges independent of
 * time-based statuses. Priority order matches the legacy getBadgeKey ordering.
 * CONFLICT is only returned when isMyCalendlyScope is true.
 */
export const getWarningKey = (
  event: any,
  isMyCalendlyScope: boolean,
  { otherEventsOnDay }: { otherEventsOnDay: any[] },
): WarningKey | null => {
  const match = warningChecks.find(
    ({ check }) => check(event, { otherEventsOnDay }, isMyCalendlyScope),
  )
  return match?.key ?? null
}
